import React from 'react'

export type ChatElement = {
  content: React.ReactElement,
  position: 'left' | 'right'
}

interface ChatAreaProps {
  elements: Array<ChatElement>
}

export const ChatArea = ({ elements }: ChatAreaProps) => {
  return (
    <>
      {elements.map((e) => {
        return (
          <div key={e.content.key} style={{ alignItems: e.position, width: '100%', float: e.position }}>
            {e.content}
          </div>
        )
      })}
    </>
  )
}
